module.exports = __webpack_public_path__ + "img/generic-banner.4a97ab86.png";